import { render, staticRenderFns } from "./room-video.vue?vue&type=template&id=9a06336a&scoped=true"
import script from "./room-video.vue?vue&type=script&lang=js"
export * from "./room-video.vue?vue&type=script&lang=js"
import style0 from "./room-video.vue?vue&type=style&index=0&id=9a06336a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a06336a",
  null
  
)

export default component.exports